module.exports = __webpack_public_path__ + "img/wa6.d01cce22.jpg";